module.exports = __webpack_public_path__ + "static/media/aldi.9fd3ef89.png";